import jQuery from 'jquery';
import React from 'react';
import styles from './Dropdown.styl';

class Dropdown extends React.Component

{
	constructor(props) {
		super(props);
	}

	onChange(value) {
		if (this.props.onItemChange) {
			this.props.onItemChange(value);
		}
	}

	render() {
		let options = null;

		if (jQuery.isArray(this.props.items))
		{
			const useValueKey = this.props.useValueKey;

			options = this.props.items.map((value, index) => {
				if (typeof value === 'object') {
					return (<option key={useValueKey ? value.value : index} value={value.value}>{value.text}</option>);
				} else {
					return (<option key={index} value={value}>{value}</option>);
				}
			});
		}
		else
		{
			options = [];

			for (let value in this.props.items)
			{
				options.push(<option key={value} value={value}>{value}</option>);
			}
		}


		let style = this.props.style ? this.props.style : {};

		if (this.props.x) {
			style.left = `${this.props.x}px`;
		}

		if (this.props.y) {
			style.top = `${this.props.y}px`;
		}

		if (this.props.width) {
			style.width = `${this.props.width}px`;
		}

		if (this.props.label)
		{
			return (
				<label className={`${styles.label} ${this.props.className}`} style={style}>
					<span className={styles.labelText}>{this.props.label}</span>
					<select
						onChange={e => this.onChange(e.target.value)}
						value={this.props.value}
						title={this.props.title ? this.props.title : null}
						className={styles.select}
						style={this.props.selectStyle ? this.props.selectStyle : {}}
						disabled={this.props.disabled}>{options}</select>
				</label>
			);
		}
		else
		{
			style.position = 'absolute';

			return (
				<select
					className={this.props.className ? this.props.className : styles.select}
					onChange={e => this.onChange(e.target.value)}
					value={this.props.value}
					title={this.props.title ? this.props.title : null}
					style={style}
					disabled={this.props.disabled}>{options}</select>
			);
		}
	}
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/react/ui/Dropdown.jsx